import PropTypes from "prop-types";

import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { formatDate, formatMoney } from "@/features/shared";

export const GeneralInformationSection = ({ salesPayment }) => {
  const totalAllocatedAmount = salesPayment.salesInvoicePayments.reduce(
    (sum, payment) => sum + payment.allocatedAmount,
    0
  );

  const totalDiscount = salesPayment.salesInvoicePayments.reduce(
    (sum, payment) => sum + payment.discount,
    0
  );

  const grandTotal = totalAllocatedAmount - totalDiscount;

  const cashAndBankAccount = salesPayment.cashBankOutletChartOfAccount;

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Umum</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Dibuat oleh
          </Typography>
          <Typography variant="body1">
            {salesPayment.creator?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Transaksi
          </Typography>
          <Typography variant="body1">
            {formatDate(salesPayment.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pelanggan
          </Typography>
          <Typography variant="body1">
            {salesPayment.buyer?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Outlet
          </Typography>
          <Typography variant="body1">
            {salesPayment.seller?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Kas & Bank
          </Typography>
          <Typography variant="body1">
            {cashAndBankAccount?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Total Diterima
          </Typography>
          <Typography variant="body1">
            {formatMoney(totalAllocatedAmount)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Total Diskon
          </Typography>
          <Typography variant="body1">
            {formatMoney(totalDiscount)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Grand Total
          </Typography>
          <Typography variant="body1" sx={{
            fontWeight: "bold"
          }}>
            {formatMoney(grandTotal)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Catatan
          </Typography>
          <Typography variant="body1">
            {salesPayment.note ?? "-"}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  salesPayment: PropTypes.object.isRequired,
};
